<template lang="pug">
.v-lk-employees.lk-employees
	.lk-employees__container
		v-loader(:loading="loading")
		.lk-employees__left(v-if="data")
			.lk-employees__head(v-if="data.title || data.addButton")
				component.lk-employees__title.h1(v-if="data.title" :is="data.titleLevel || 'h1'") {{data.title}}
				.lk-employees__info(v-if="data?.user && isSm")
					.profile-info(v-if="data?.user")
						.profile-info__head(v-if="data.user.logo && data.user.logo.src")
							img.profile-info__head-img(:src="data.user.logo.src" :alt="data.user.logo.alt")
						.profile-info__label(v-if="data.user.name") {{data.user.name}}
						.profile-info__desc(v-if="data.user.desc") {{data.user.desc}}`

				.lk-employees__action
					button.btn.btn--primary.btn--round(v-if="data.addButton" @click="requestAdd(data.addButton?.action)") {{data.addButton.text || 'Добавить сотрудника'}}
			.lk-employees__content(v-if="data.items && data.items.length")
				template(v-for="(item, index) in data.items" :key="index" )
					v-lk-employees-card(:item="item"
						@edit="requestEdit"
						@remove="requestRemove"
						@block="requestBlock"
						@unblock="requestUnblock"
					)
			.lk-employees__pagination(v-if="page && page.count > page.limit")
				v-page-nav(:page="page" :limits="limits" @navigate="navigate")
		.lk-employees__right(v-if="data && !isSm")
			.profile-info(v-if="data?.user")
				.profile-info__head(v-if="data.user.logo")
					img.profile-info__head-img(:src="data.user.logo.src" :alt="data.user.logo.alt")
				.profile-info__label(v-if="data.user.name") {{data.user.name}}
				.profile-info__desc(v-if="data.user.desc") {{data.user.desc}}
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
	import controller from '../scripts/controller/controller.js';

	export default {
		mixins: [
			sourceMixin,
			isMobMixin
		],

		data() {
			return {
				data: null,
				timerId: null,
				page: null
			}
		},

		methods: {
			dataSet(data) {

				if(data.type === 'edit-user') {
					controller.openModal({
						component: {
							name: "v-add-employee-form",
							props: {
								dataSource: data,
							}
						}
					})
					return;
				}

				this.data = data;
				this.page = data.page;
				this.limits = data.limits;

				if(this.data.modal) {
					controller.openModal({
						...this.data.modal,
					})
				}
			},

			updateUsers() {
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						action: 'update-users',
					}
				});
			},

			navigate(page) {
				this.page.offset = page.offset;
				this.page.limit = page.limit;
				this.requestDataLoad();
			},

			requestAdd(action = 'new') {
				this.requestDataLoad({
					remote: this.data.remote,
					action
				})
			},

			requestRemove({id, action}) {
				if(this.data.modalConfirmRemove) {
					controller.openModal({
						component: {
							...this.data.modalConfirmRemove,
							listeners: {
								'confirm': async () => {
									this.requestDataLoad({
										remote: this.data.remote,
										action,
										id,
									})
								},
							}
						}
					});
				} else {
					this.requestDataLoad({
						remote: this.data.remote,
						action,
						id,
					})
				}
			},

			requestEdit({id, action, remote}) {
				this.requestDataLoad({
					remote,
					action,
					id,
				})
			},

			requestBlock({id, action}) {
				if(this.data.modalConfirmBlock) {
					controller.openModal({
						component: {
							...this.data.modalConfirmBlock,
							listeners: {
								'confirm': async () => {
									this.requestDataLoad({
										remote: this.data.remote,
										action,
										id,
									})
								},
							}
						}
					});
				} else {
					this.requestDataLoad({
						remote: this.data.remote,
						action,
						id,
					})
				}
			},

			requestUnblock({id, action}) {
				if(this.data.modalConfirmUnblock) {
					controller.openModal({
						component: {
							...this.data.modalConfirmUnblock,
							listeners: {
								'confirm': async () => {
									this.requestDataLoad({
										remote: this.data.remote,
										action,
										id,
									})
								},
							}
						}
					});
				} else {
					this.requestDataLoad({
						remote: this.data.remote,
						action,
						id,
					})
				}
			},

			requestDataLoad({remote = this.data.remote, action = null, id = null}) {
				clearTimeout(this.timerId);

				this.timerId = setTimeout(() => {
					this.dataLoad({
						url: remote,
						delay: true,
						data: {
							id,
							action,
						}
					}, remote);
				},500)

			},

		},

		created() {
			controller.events.on('update-users', this.updateUsers);
		}
	}
</script>
